import { SET_USERDATA } from '../../Types/UserData';

export const setUserData = (payload) => ({
  type: SET_USERDATA,
  payload,
});
